import { DEFAULT_USER_ROLE } from '@common/constants/request.constants'
import { AuthLink } from '@common/enums/request.enums'
import { LocalStorageUtils } from '@common/utils/localStorage.utils'
import Loader from '@components/state/Loader'
import { Route } from '@config/routes/routes.enums'
import { useAuth } from '@services/contexts/AuthContext'
import { useEffect } from 'react'
import { Navigate, Outlet } from 'react-router-dom'

type ProtectedRouteProps = {
	roles?: string[]
}

/**
 * Protected route
 * @param roles
 * @constructor
 */
const ProtectedRoute = ({ roles }: ProtectedRouteProps) => {
	const { isAuthenticating, user } = useAuth()
	const hasToken = !!LocalStorageUtils.getToken()

	// Redirect once the loader is rendered, so that it stays displayed while the browser navigates
	useEffect(() => {
		if (!hasToken) {
			window.location.href = AuthLink.LOG_IN + `?redirect_uri=${window.location.pathname}`
		}
	}, [hasToken])

	if (!hasToken) {
		return <Loader />
	}

	if (user.role !== DEFAULT_USER_ROLE) {
		if (!user.role) {
			return <Navigate to={`/${Route.UNAUTHORIZED}`} replace />
		} else if (roles && !roles.includes(user.role)) {
			return <Navigate to={`/${Route.FORBIDDEN}`} replace />
		}

		return <Outlet />
	}

	// The role is not resolved yet : the token request is still pending
	return isAuthenticating ? <Loader /> : <></>
}

export default ProtectedRoute
